"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ActionCardList_styles_1 = require("./ActionCardList.styles");
const EmptyElements_1 = require("./EmptyElements");
/** A component for rendering a list of small, interactive cards */
const ActionCardList = react_1.default.forwardRef((_a, ref) => {
    var { id, children, minItemWidth = 200, maxElements = 0, showEmpty = maxElements, showCount = false, showMoreThanMax = false } = _a, rest = __rest(_a, ["id", "children", "minItemWidth", "maxElements", "showEmpty", "showCount", "showMoreThanMax"]);
    const numElements = react_1.default.Children.count(children);
    return (react_1.default.createElement(ActionCardList_styles_1.Container, Object.assign({ showCount: showCount }, rest, { ref: ref, "data-ref": ref ? 'set' : 'unset' }),
        react_1.default.createElement(ActionCardList_styles_1.ListContainer, { id: id, minItemWidth: minItemWidth },
            react_1.default.Children.map(children, (child, idx) => {
                var _a;
                if (!showMoreThanMax && maxElements && idx >= maxElements)
                    return null;
                const key = (_a = (react_1.default.isValidElement(child) && child.props.id)) !== null && _a !== void 0 ? _a : idx;
                return react_1.default.createElement(ActionCardList_styles_1.ListItem, { key: key }, child);
            }),
            react_1.default.createElement(EmptyElements_1.EmptyElements, { numElements: numElements, maxElements: maxElements, showEmpty: showEmpty })),
        showCount && (react_1.default.createElement(ActionCardList_styles_1.Count, { exceedsMax: !!maxElements && numElements > maxElements }, maxElements ? `${numElements} / ${maxElements}` : numElements))));
});
ActionCardList.displayName = 'ActionCardList';
exports.default = ActionCardList;
//# sourceMappingURL=ActionCardList.js.map